/* eslint-disable no-new */
import Cookies from 'universal-cookie';

const cookies = new Cookies();

/** Must match options used in setCookies so remove always clears the stored cookie. */
const COOKIE_BASE_OPTS = { path: '/', sameSite: 'Strict' };

export const getCookies = (value = '') => cookies.get(value);

export const removeCookies = (value = '') =>
  new Promise((resolve) => {
    cookies.remove(value, COOKIE_BASE_OPTS);
    resolve();
  });

/** All panel-auth cookies set on login — clear together so logout is reliable. */
export const clearAdminAuthCookies = () => {
  [
    'Token',
    'refreshToken',
    'USERPERMISSION',
    'USERID',
    'USERROLE',
    'USERNAME',
    'PROFILE',
  ].forEach((key) => {
    cookies.remove(key, COOKIE_BASE_OPTS);
  });
};

export const setCookies = (key = '', value = '') => {
  cookies.set(key, value, {
    path: '/',
    sameSite: 'Strict',
  });
};
